import { defineStore } from 'pinia'

import * as authApi from '@/api/auth'
import { getToken, getUser, persistSession, persistUser, clearSession } from '@/utils/session'
import { usePermissionsStore } from './permissions'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: getToken(),
    user: getUser()
  }),

  getters: {
    isAuthenticated: (state) => !!state.token
  },

  actions: {
    async login(credentials) {
      const { data } = await authApi.login(credentials)
      this.setSession(data, !!credentials.remember)
      return data
    },

    // Expected payload: { token, user, permissions }
    setSession(data, remember = false) {
      this.token = data.token || null
      this.user = data.user || null
      persistSession(this.token, this.user, remember)
      usePermissionsStore().setPermissions(data.permissions || [])
    },

    async fetchCurrentUser() {
      const { data } = await authApi.fetchCurrentUser()
      this.user = data.user || data
      persistUser(this.user)
      if (data.permissions) {
        usePermissionsStore().setPermissions(data.permissions)
      }
      return this.user
    },

    setUser(user) {
      this.user = user || null
      persistUser(this.user)
    },

    logout() {
      // Best-effort server-side invalidation; never block local sign-out on it.
      if (this.token) authApi.logout().catch(() => {})
      this.token = null
      this.user = null
      clearSession()
      usePermissionsStore().clear()
    }
  }
})
